<script lang="ts">
    import { RewardsPopUpRootWidgetDefinition } from "@apps/rewards/constants/definitions";
    import type { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
    import type { ExtractModuleType } from "@modules/dynamic_import/types";
    import type { Observable } from "rxjs";

    //Props
    export let shouldImportWidget: Observable<boolean>;
    export let dynamicImportManager: DynamicImportManager;

    let WidgetComponent: ExtractModuleType<
        typeof RewardsPopUpRootWidgetDefinition
    >["default"];

    const importWidget = async () => {
        if (WidgetComponent) return;

        try {
            WidgetComponent = await dynamicImportManager.importDefault(
                RewardsPopUpRootWidgetDefinition,
                true
            );
        } catch (error) {
            console.error(
                "Failed to load RewardsPopUpRootWidget module",
                error
            );
        }
    };

    $: if ($shouldImportWidget) importWidget();
</script>

<slot value={{ WidgetComponent, importWidget }} />
